import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Banner } from 'src/app/models/banner';
import { BannerLocationEnum } from 'src/app/models/banner-location-enum';
import { BannerTypeIconEnum } from 'src/app/models/banner-type-icon-enum';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: false
})
export class BannerComponent implements OnInit, OnDestroy {

  banners: Banner[] = [];
  location = '';
  isMobileView = false;

  private readonly rxSubs = new Subscription();

  @Input()
  set _banners(banners: Banner[]) {
    this.banners = this.locationFilteredBanners(banners) ?? [];
  }


  constructor(
    private readonly router: Router,
    private readonly breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit(): void {
    this.location = this.router.url;
    this.rxSubs.add(this.breakpointObserver.observe(['(min-width: 600px)']).subscribe((result: BreakpointState) => {
      this.isMobileView = !result.matches;
    }));
  }

  ngOnDestroy(): void {
    this.rxSubs.unsubscribe();
  }


  getIcon(banner: Banner): string {
    return BannerTypeIconEnum[banner.Type];
  }

  locationFilteredBanners(banners: Banner[]): Banner[] {
    let workCenter = '';
    let feature = '';
    // landing page
    if (this.location !== '/') {
      workCenter = this.location?.split('/')[1]?.toLowerCase() ?? '';
      feature = this.location?.split('/')[2]?.toLowerCase() ?? '';

    }


    const onlyBannerMatchingRequestedType = banners?.filter((banner) => {
      return banner.Location === BannerLocationEnum.Sitewide ||
        (banner.WorkCenter && banner.Location === BannerLocationEnum.WorkCenter && banner.WorkCenter.toLowerCase() === workCenter) ||
        (banner.Application && banner.Location === BannerLocationEnum.Application && banner.Application.replace(/\s+/g, '').toLowerCase() === feature);
    });

    return onlyBannerMatchingRequestedType ?? [];
  }

}
